import AdminLayout from "./AdminLayout";
import AdminOverview from "./AdminOverview";

export default function AdminOverviewPage() {
  return (
    <AdminLayout>
      <AdminOverview />
    </AdminLayout>
  );
}
